import React, { useState, useEffect, useRef, useCallback } from 'react';
import TopBar from '../../Components/Games/TopBar.jsx';
import ResultPage from '../../Components/Games/ResultPage.jsx';
import StartGame from '../../Components/Games/StartGame.jsx';
import GameIntroScreen from '../../Components/Games/GameIntroScreen.jsx';
import overlay from '../../assets/img/overlay.png';
import focusHoldIcon from '../../assets/img/icon-Focus-Hold.png';
import './FocusHold.css';
import { lifestyleApi } from '../../apiService/api';
import { getUrlParams } from '../../apiService/timespam';
import { useGameBackNavigation } from "../../Components/Games/useGameBackNavigation";

const FocusHold = () => {
    useGameBackNavigation();
    const [screen, setScreen] = useState("intro");
    const [gameState, setGameState] = useState('START');
    const [tutorialStep, setTutorialStep] = useState(0);

    const [popMsg, setPopMsg] = useState(null);
    const [popType, setPopType] = useState("");

    const [score, setScore] = useState(0);
    const [bestScore, setBestScore] = useState(() => Number(localStorage.getItem('focusHoldBest')) || 0);
    const [timeLeft, setTimeLeft] = useState(60);
    const [targetPos, setTargetPos] = useState({ x: 50, y: 50 });
    const [isFocused, setIsFocused] = useState(false);
    const [streak, setStreak] = useState(0);
    const [bestStreak, setBestStreak] = useState(0);
    const [popScore, setPopScore] = useState(null);
    const [difficulty, setDifficulty] = useState(1);

    const [wrongCount, setWrongCount] = useState(0);
    const [fastResponses, setFastResponses] = useState(0);
    const [cid, setCid] = useState("");
    const [groupName, setGroupName] = useState("");
    const [gameStateApi, setGameStateApi] = useState("initial");
    const [lastInsertedId, setLastInsertedId] = useState(null);
    const [backendCognitiveScore, setBackendCognitiveScore] = useState(null);
    const [backendSkill, setBackendSkill] = useState("");
    const [weightages, setWeightages] = useState({ attemptWeightage: 1, accuracyWeightage: 1, streakWeightage: 1, fastWeightage: 1, scoreWeightage: 1, baseQuestionsAttempt: 0, correctMinQuestion: 1, streakMinQuestion: 1, fastResponseMinQuestion: 1, scorePoints: 1 });
    const [configError, setConfigError] = useState(false);

    const [goqiiBest, setGoqiiBest] = useState(0);

    const velocity = useRef({ x: 0.22, y: 0.28 });
    const requestRef = useRef(null);
    const containerRef = useRef(null);
    const timerRef = useRef(null);
    const userPos = useRef({ x: -100, y: -100 });
    const lastLostTime = useRef(0);

    const lastFrameTime = useRef(performance.now());
    const focusStartTime = useRef(0);
    const lastScoreAwardTime = useRef(0);
    // Consecutive 1-second hold-ticks since focus was last lost (used as the
    // streak multiplier for the unified score formula). Purely additive -
    // does NOT replace the existing `streak`/`bestStreak` duration state.
    const holdTickStreakRef = useRef(0);
    // Set when the "quickly re-acquired the target" fast-response condition
    // fires; consumed (and cleared) by the next 1s score tick.
    const pendingFastBonusRef = useRef(false);


    const fetchGameConfig = () => {
        setConfigError(false);
        const { encryptedId, gid } = getUrlParams();

        lifestyleApi.fetchGameDetails(encryptedId, gid)
            .then(res => {
                if (res.data?.code === 200) {
                    const d = res.data.data;
                    setBestScore(d.bestScore);
                    setGoqiiBest(d.goqiiBest);
                    setWeightages({
                        attemptWeightage: d.attemptWeightage ?? 1,
                        accuracyWeightage: d.accuracyWeightage ?? 1,
                        streakWeightage: d.streakWeightage ?? 1,
                        fastWeightage: d.fastWeightage ?? 1,
                        scoreWeightage: d.scoreWeightage ?? 1,
                        baseQuestionsAttempt: d.baseQuestionsAttempt || 0,
                        correctMinQuestion: d.correctMinQuestion || 1,
                        streakMinQuestion: d.streakMinQuestion || 1,
                        fastResponseMinQuestion: d.fastResponseMinQuestion || 1,
                        scorePoints: d.scorePoints || 1,
                    });
                } else {
                    setConfigError(true);
                }
            })
            .catch(err => {
                console.error("fetchGameDetails failed", err);
                setConfigError(true);
            });
    };

    useEffect(() => {
        fetchGameConfig();
    }, []);

    const updatePhysics = useCallback(() => {
        if (gameState === 'TUTORIAL' && tutorialStep === -1) {
            requestRef.current = requestAnimationFrame(updatePhysics);
            return;
        }
        const now = performance.now();
        const deltaTime = (now - lastFrameTime.current) / 16.67;
        lastFrameTime.current = now;
        setTargetPos(prev => {
            const boardWidth = containerRef.current?.offsetWidth || 500;
            const speedNormalization = 500 / boardWidth;
            const speedMult = gameState === 'TUTORIAL' ? 0.45 : difficulty;
            // Movement adjusted by deltaTime
            let newX = prev.x + (velocity.current.x * speedMult * deltaTime * speedNormalization);
            let newY = prev.y + (velocity.current.y * speedMult * deltaTime * speedNormalization);


            if (newX <= 12) { newX = 12.1; velocity.current.x = Math.abs(velocity.current.x); }
            if (newX >= 88) { newX = 87.9; velocity.current.x = -Math.abs(velocity.current.x); }
            if (newY <= 15) { newY = 15.1; velocity.current.y = Math.abs(velocity.current.y); }
            if (newY >= 85) { newY = 84.9; velocity.current.y = -Math.abs(velocity.current.y); }
            // if (dist < radius) {

            if (!containerRef.current) return;
            const rect = containerRef.current.getBoundingClientRect();

            // Collision Check in Pixels (Har screen par target pakadna ek jaisa lagega)
            const targetPxX = (newX / 100) * rect.width;
            const targetPxY = (newY / 100) * rect.height;
            const userPxX = (userPos.current.x / 100) * rect.width;
            const userPxY = (userPos.current.y / 100) * rect.height;

            const distPx = Math.hypot(userPxX - targetPxX, userPxY - targetPxY);

            // 50px mobile thumb ke liye best hai, 40px desktop ke liye
            const hitRadiusPx = window.innerWidth < 600 ? 50 : 40;

            if (distPx < hitRadiusPx) {
                const currentTime = Date.now();
                if (!isFocused) {
                    setIsFocused(true);
                    focusStartTime.current = currentTime;
                    lastScoreAwardTime.current = currentTime;

                    if (gameState === 'PLAYING' && lastLostTime.current > 0) {
                        if (currentTime - lastLostTime.current < 1000) {
                            setFastResponses(prev => prev + 1);
                            pendingFastBonusRef.current = true;
                        }
                        lastLostTime.current = 0;
                    }
                    if (gameState === 'TUTORIAL' && tutorialStep === 0) setTutorialStep(1);
                }

                // --- TIME BASED SCORING AND STREAK ---
                const heldDurationMs = currentTime - focusStartTime.current;

                // Update Streak visually (60 units = 1 second to keep your UI logic)
                const currentStreakUnits = (heldDurationMs / 1000) * 60;
                setStreak(currentStreakUnits);

                if (gameState === 'PLAYING') {
                    // Award points every 1000ms (1 second)
                    if (currentTime - lastScoreAwardTime.current >= 1000) {
                        // streak multiplier = consecutive hold-ticks BEFORE this tick
                        const streakBeforeThisTick = holdTickStreakRef.current;
                        const streakBonus = weightages.streakWeightage * 10 * streakBeforeThisTick;
                        let fastBonus = 0;
                        if (pendingFastBonusRef.current) {
                            fastBonus = weightages.fastWeightage * 10;
                            pendingFastBonusRef.current = false;
                        }
                        const gained = weightages.scorePoints + streakBonus + fastBonus;
                        setScore(prev => Math.max(0, prev + gained));
                        holdTickStreakRef.current += 1;
                        lastScoreAwardTime.current = currentTime;

                        // Milestone every 5 seconds
                        if (Math.floor(heldDurationMs / 1000) % 5 === 0 && heldDurationMs > 1000) {
                            setPopType("success");
                            setPopMsg("GREAT! 🔥");
                            setTimeout(() => setPopMsg(null), 600);
                        }
                    }
                } else if (gameState === 'TUTORIAL' && tutorialStep === 1) {
                    const heldDurationMs = currentTime - focusStartTime.current;
                    setStreak((heldDurationMs / 1000) * 60);
                    if (heldDurationMs >= 2000) { // Exactly 2 seconds
                        finishTutorial();
                    }
                }
            } else {
                if (isFocused) {
                    setIsFocused(false);
                    setStreak(0);
                    if (gameState === 'PLAYING') {
                        setWrongCount(prev => prev + 1);
                        lastLostTime.current = Date.now();
                        setPopType("error");
                        setPopMsg("Oops! ⚠️");
                        setPopScore("FOCUS LOST!");
                        // Penalty: half the configured score points, for failing
                        setScore(prev => Math.max(0, prev - weightages.scorePoints / 2));
                        holdTickStreakRef.current = 0;
                        setTimeout(() => { setPopMsg(null); setPopScore(null); }, 800);
                    }
                }
            }

            return { x: newX, y: newY };
        });

        // Direction jitter adjusted by deltaTime
        if (Math.random() > 0.985) {
            velocity.current.x += (Math.random() - 0.5) * 0.12 * deltaTime;
            velocity.current.y += (Math.random() - 0.5) * 0.12 * deltaTime;
        }
        requestRef.current = requestAnimationFrame(updatePhysics);
    }, [difficulty, gameState, tutorialStep, isFocused, weightages]);

    const handleInteraction = (clientX, clientY) => {
        if ((gameState !== 'PLAYING' && gameState !== 'TUTORIAL') || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        userPos.current = {
            x: ((clientX - rect.left) / rect.width) * 100,
            y: ((clientY - rect.top) / rect.height) * 100
        };
    };


    const startGame = async (isReplay = false) => {
        const { encryptedId, gid } = getUrlParams();

        try {
            const res = await lifestyleApi.initialGameScore(encryptedId, gid);

            if (res.data?.code === 200) {
                const data = res.data.data;

                setCid(data.cid);
                setGroupName(data.groupName);
                setLastInsertedId(data.lastInsertedId);
                setGameStateApi("initial");
            }
        } catch (err) {
            console.error("initialGameScore failed", err);
        }
        setPopMsg(null);
        setPopType("");
        setPopScore(null);

        setScore(0);
        setTimeLeft(60);
        setStreak(0);
        setBestStreak(0);
        setWrongCount(0);
        setFastResponses(0);
        setDifficulty(1);
        setIsFocused(false);
        holdTickStreakRef.current = 0;
        pendingFastBonusRef.current = false;

        // ✅ 3. RESET POSITIONS
        userPos.current = { x: -100, y: -100 };
        setTargetPos({ x: 50, y: 50 }); // Reset target to center
        //  velocity.current = { x: 0.22, y: 0.28 }; 
        lastFrameTime.current = performance.now()

        setScreen('game');
        if (isReplay) {
            setGameState('TUTORIAL');
            setTutorialStep(-1);

            // After 1.6 seconds (the animation time), start the actual game
            setTimeout(() => {
                setGameState('PLAYING');
                startTimer();
            }, 1600);
        }
        else { setGameState('TUTORIAL'); setTutorialStep(0); }
    };

    const finishTutorial = () => {
        setTutorialStep(-1); setStreak(0); setIsFocused(false);
        setTimeout(() => { lastFrameTime.current = performance.now(); setGameState('PLAYING'); startTimer(); }, 1600);
    };

    const clearUserPos = () => {
        userPos.current = { x: -100, y: -100 };
        setIsFocused(false);
        setStreak(0);
    };

    const startTimer = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) { clearInterval(timerRef.current); setGameState('GAMEOVER'); return 0; }
                if (prev % 10 === 0) setDifficulty(d => d + 0.18);
                return prev - 1;
            });
        }, 1000);
    };

    useEffect(() => {
        if (gameState === 'PLAYING' || gameState === 'TUTORIAL') {
            lastFrameTime.current = performance.now();
            requestRef.current = requestAnimationFrame(updatePhysics);
        } else { cancelAnimationFrame(requestRef.current); }
        return () => cancelAnimationFrame(requestRef.current);
    }, [gameState, updatePhysics]);

    useEffect(() => { if (streak > bestStreak) setBestStreak(streak); }, [streak, bestStreak]);

    useEffect(() => {
        if (gameState === 'GAMEOVER' && score > bestScore) {
            setBestScore(score);
            localStorage.setItem('focusHoldBest', score.toString());
        }
    }, [gameState, score, bestStreak]);

    useEffect(() => { return () => clearInterval(timerRef.current); }, []);

    const saveFinalGameScore = async () => {
        const { encryptedId, gid } = getUrlParams();
        const goqiiUserId = encryptedId;
        const totalSecondsFocused = Math.floor(score / 100);
        const longestFocusSession = Math.floor(bestStreak / 60);
        const totalQuestions = totalSecondsFocused + wrongCount;

        const payload = {
            goqiiUserId,
            gid,
            totalQuestions,
            correctAnswers: totalSecondsFocused,
            wrongAnswers: wrongCount,
            longestStreak: longestFocusSession,
            fastResponse: fastResponses,
            score,
            cid,
            lastInsertedId,
        };

        try {
            const res = await lifestyleApi.saveGameScore(
                payload.goqiiUserId,
                payload.gid,
                payload.totalQuestions,
                payload.correctAnswers,
                payload.wrongAnswers,
                payload.longestStreak,
                payload.fastResponse,
                payload.score,
                payload.cid,
                payload.lastInsertedId
            );

            if (res?.data?.data?.cognitiveScore !== undefined) {
                setBackendCognitiveScore(res.data.data.cognitiveScore);
            }
            if (res?.data?.data?.skill) {
                setBackendSkill(res.data.data.skill);
            }
        } catch (err) {
            console.error("saveGameScore failed", err);
        }
    };

    useEffect(() => {
        if (gameState === 'GAMEOVER') {
            saveFinalGameScore();
        }
    }, [gameState]);

    const getQuote = () => {
        const focusSeconds = Math.floor(bestStreak / 60);

        if (backendCognitiveScore >= 90 || focusSeconds >= 15)
            return "Laser-like focus! You can hold attention under pressure.";
        if (backendCognitiveScore >= 75 || focusSeconds >= 10)
            return "Strong concentration! Your mind stays locked in.";
        if (backendCognitiveScore >= 60 || focusSeconds >= 6)
            return "Good control. Your sustained focus is improving.";
        if (backendCognitiveScore >= 40)
            return "Nice effort. Longer focus builds mental strength.";
        return "Every second of focus trains your brain. Keep practicing!";
    };


    return (
        <div className={`fh-main-container ${isFocused ? 'active-bg' : ''}`}>
            {configError && (
                <div className="api-error-overlay">
                    <div className="api-error-card">
                        <div className="api-error-title">Something went wrong</div>
                        <div className="api-error-text">There is a server error to open this game. Please try again after some time.</div>
                        <button className="api-error-retry-btn" onClick={fetchGameConfig}>Retry</button>
                    </div>
                </div>
            )}

            {screen === "game" && gameState !== 'TUTORIAL' && <TopBar score={score} timeLeft={timeLeft} />}

            <div className="fh-main-area">
                {screen === "intro" ? (
                    <GameIntroScreen backgroundImage={overlay} gameLogo={focusHoldIcon} title="Focus Hold" onStart={() => setScreen("start")} />
                ) : gameState === 'START' ? (
                    <StartGame backgroundImage={overlay}
                        
                        hbHeading="Sustained Focus" hbDescription="Staying focused on a moving object helps you ignore distractions and keep your mind on the task." yourBest={bestScore} goqiiBest={goqiiBest} onStart={() => startGame(false)} />
                ) : gameState === 'GAMEOVER' ? (
                    <ResultPage
                        visible={true} score={score} best={bestScore}
                        correct={Math.floor(bestStreak / 60)}
                        wrong={wrongCount}
                        longestStreak={Math.floor(bestStreak / 60)}
                        fastResponses={fastResponses}
                        cognitiveScore={backendCognitiveScore}
                        domainLabel={backendSkill}
                        onReplay={() => startGame(true)}
                        quote={getQuote()}
                    />
                ) : (
                    <div className="fh-game-board">

                        {popMsg && <div className={`fh-pop-msg ${popType}`}>{popMsg}</div>}
                        {popScore && !popMsg && <div className="fh-pop-msg error">{popScore}</div>}

                        {gameState === 'TUTORIAL' && (
                            <div className={`fh-tutorial-overlay ${tutorialStep === -1 ? 'starting' : ''}`}>
                                {tutorialStep === -1 && <div className="fh-big-start">START!</div>}
                                {tutorialStep !== -1 && (
                                    <>
                                        <div className="fh-tutorial-top-row">
                                            <div className="fh-tutorial-badge">Tutorial</div>

                                            <button
                                                className="fh-skip-btn"
                                                onClick={(e) => { e.stopPropagation(); finishTutorial(); }}
                                            >
                                                Skip ⏩
                                            </button>
                                        </div>
                                        {/* <button className="fh-skip-btn" onClick={(e) => { e.stopPropagation(); finishTutorial(); }}>Skip ⏩</button> */}
                                        {tutorialStep === 0 && <div className="fh-guide-step target-guide"><p>Touch the <strong>Target</strong></p></div>}
                                        {tutorialStep === 1 && (
                                            <div className="fh-guide-step hold-guide">
                                                <p className={isFocused ? 'txt-success' : 'txt-error'}>
                                                    {isFocused ? "Great! Hold it..." : "Don't let go! ⚠️"}
                                                </p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                        <div
                            className="fh-interaction-zone"
                            ref={containerRef}
                            onMouseMove={(e) => handleInteraction(e.clientX, e.clientY)}
                            onMouseLeave={clearUserPos}

                            // MOBILE FIXES HERE:
                            onTouchMove={(e) => handleInteraction(e.touches[0].clientX, e.touches[0].clientY)}
                            onTouchEnd={clearUserPos}
                            onTouchCancel={clearUserPos}
                        >
                            <div className="fh-hud">
                                {!isFocused && (gameState === 'PLAYING' || gameState === 'TUTORIAL') && (
                                    <div className="fh-hint">TOUCH & HOLD TO CONTINUE</div>
                                )}
                            </div>

                            <div
                                className={`fh-target ${isFocused ? 'focused' : ''} ${popType === 'error' && !isFocused ? 'shake' : ''}`}
                                style={{ left: `${targetPos.x}%`, top: `${targetPos.y}%` }}
                            >
                                <div className="fh-target-core"></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FocusHold;